import * as React from "react";
import { IconProps } from "../types";

const TemperatureIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M4.75 10.806V4.75C4.75 3.369 5.869 2.25 7.25 2.25C8.631 2.25 9.75 3.369 9.75 4.75V10.806C10.367 11.437 10.75 12.298 10.75 13.25C10.75 15.183 9.183 16.75 7.25 16.75C5.317 16.75 3.75 15.183 3.75 13.25C3.75 12.298 4.133 11.437 4.75 10.806Z"
          fill={color}
          fill-opacity="0.15"
        />
        <path
          d="M7.25 12.5V7.25"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.75 10.806V4.75C4.75 3.369 5.869 2.25 7.25 2.25C8.631 2.25 9.75 3.369 9.75 4.75V10.806C10.367 11.437 10.75 12.298 10.75 13.25C10.75 15.183 9.183 16.75 7.25 16.75C5.317 16.75 3.75 15.183 3.75 13.25C3.75 12.298 4.133 11.437 4.75 10.806Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.25 14.75C8.07843 14.75 8.75 14.0784 8.75 13.25C8.75 12.4216 8.07843 11.75 7.25 11.75C6.42157 11.75 5.75 12.4216 5.75 13.25C5.75 14.0784 6.42157 14.75 7.25 14.75Z"
          fill={color}
        />
        <path
          d="M15.25 4.25H12.75"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.25 7.25H12.75"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.25 10.25H12.75"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
);

export default TemperatureIcon;
